import {useCustomerResponse} from '@aboutyou/user';
import {useShowCampaignPhonePopup} from '../../../backend-services/Campaigns/hooks/useShowCampaignPhonePopup';
import {useIsAppWelcomeCouponBannerEnabled} from '../../Coupons/useIsAppWelcomeCouponBannerEnabled';
import {useIsCouponsEnabled} from '../../Coupons/useIsCouponsEnabled';

export const useIsGenericWebCouponBannerEnabled = () => {
  const isCouponsActive = useIsCouponsEnabled();
  const isAppWelcomeCouponBannerEnabled = useIsAppWelcomeCouponBannerEnabled();
  const showCampaignPhonePopup = useShowCampaignPhonePopup();
  const customerResponse = useCustomerResponse();

  return (
    isAppWelcomeCouponBannerEnabled &&
    isCouponsActive &&
    !showCampaignPhonePopup &&
    customerResponse.data &&
    customerResponse.data.showAppInstallBanner
  );
};
